// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2SEEo","bigColWidth":"Table_bigColWidth__3pBXa","biggerColWidth":"Table_biggerColWidth__1yWXp","row":"Table_row__11JSs","col":"Table_col__3qz7t"};